import React from "react";

import Error from "../error/error";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //we could potentially identify info to pass to our error component here
  }

  render() {

    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <Error/>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;